/**
 * Constantes compartidas de la aplicación
 */

// Colecciones de Firebase
export const COLLECTIONS = {
  PRODUCTOS: 'Productos',
  PEDIDOS: 'Pedidos',
};

// Rutas de la aplicación
export const ROUTES = {
  HOME: '/',
  FUNDAS: '/fundas',
  ACCESORIOS: '/accesorios',
  VIDRIOS: '/vidrios',
  CARRITO: '/carrito',
  COMPRA_EXITOSA: '/compra-exitosa',
  PEDIDO_REGISTRADO: '/pedido-registrado',
  CHECKOUT_FAILURE: '/checkout/failure',
  CHECKOUT_PENDING: '/checkout/pending',
  LOGIN: '/login',
  ADMIN: '/admin',
  ADMIN_PRODUCTOS: '/admin/productos',
  ADMIN_PEDIDOS: '/pedidos',
};

// Categorías de productos
export const CATEGORIAS = {
  FUNDAS: 'fundas',
  ACCESORIOS: 'accesorios',
  VIDRIOS: 'vidrios',
};

// Estados de pedidos
export const ESTADOS_PEDIDO = {
  CREADO: 'CREADO',
  PENDIENTE: 'PENDIENTE',
  EN_PROCESO: 'EN_PROCESO',
  COMPLETADO: 'COMPLETADO',
  CANCELADO: 'CANCELADO',
};

// Configuración de precios
export const PRECIO_CONFIG = {
  MINIMO_MAYORISTA: 60000,
  CANTIDAD_MINIMA_MAYORISTA: 6,
  COMISION_HIGHER: 0.02, // 2%
};

// Configuración de contacto
export const CONTACTO = {
  WHATSAPP_NUMERO: '5491156067007',
  WHATSAPP_DISPLAY: '11-5606-7007',
};

// Storage keys
export const STORAGE_KEYS = {
  CARRITO: 'carrito',
  JWT_TOKEN: 'icase_jwt_token',
  MP_CHECKOUT_INTENT_ID: 'mp_checkout_intent_id',
  /** @deprecated usar MP_CHECKOUT_INTENT_ID */
  MP_CHECKOUT_PEDIDO_ID: 'mp_checkout_pedido_id',
  WHATSAPP_PEDIDO_PREFIX: 'whatsapp_pedido_',
};

